
import { ChangeDetectorRef, Component, OnDestroy, ViewChild, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatDrawer } from '@angular/material/sidenav';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { TreeNode } from 'primeng/api';
import { isNull } from 'lodash';
import { DataIFace } from 'app/datasources/sparkplug/register-edge/register-edge.component';
import { RangeModelComponent } from 'app/shared/panels/range-model/range-model.component';
import { DashboardSidebarService } from './dashboard-sidebar/services/dashboard-sidebar.service';
import { EventbusConnectionService } from 'app/services/eventbus-connection.service';
import { PanelService } from 'app/shared/panels/chart/Services/panel.service';
import { IFeatures, IPerspectiveDashboard } from 'app/services/graphqlApi.service';
import { DynamicDrawerService } from '../../shared/dynamic-drawer.service';
import { CommonService } from 'app/shared/services';
import { IDashboardResponse, IGlobalLineCharts, IRangeForm, ISummaryTimeStamp } from 'app/shared/panels/chart/Models/chart-settings.model';
import { EEntityTypes, ERanges, EViewTypes } from 'app/shared/enums';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { IDropdown } from 'app/shared/interfaces/model';

@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['./full.component.scss']
})

export class FullComponent implements OnInit, OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  selectedAssetName: string = '';
  selectedGroupName: string = '';
  selectedDashboardName: string = '';
  selectedAssetLiveStatus: string = '';
  isOfflineWithTimeDiff: boolean = false;
  selectedAssetTimeStamp: string = ''; // linked or unlinked timestamp
  currentDate: any;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  showHide: boolean;
  url: string;
  sidebarOpened: boolean = true;
  showDashboard: boolean = false;
  iconWithText: boolean = true;
  isShowing: boolean = true;
  globalLineCharts: IGlobalLineCharts;
  rangeModel: IRangeForm = { range: null, rangeName: '', fromDate: null, toDate: null };
  showRangeValues: boolean = false;
  showIconButtons: boolean = false;
  isLightMode: boolean = false;
  count: number = 0;
  defaultCount: number = 2;
  public showSearch = false;
  ranges: IDropdown[] = [{ name: 'Last 1H', value: ERanges.H1 }, { name: 'Last 6H', value: ERanges.H6 }, { name: 'Last 12H', value: ERanges.H12 }, { name: 'Last 1D', value: ERanges.D1 }, { name: 'Last 1W', value: ERanges.W1 }, { name: 'Last 1M', value: ERanges.M1 }, { name: 'Last 3M', value: ERanges.M3 }];
  allDashboards: IDashboardResponse[] = [];
  dashboardsWithChildren: IDashboardResponse[] = [];
  featuresDetails: IFeatures[] = [];
  allFeaturesNames: string[] = [];
  isAdminView: boolean = true; // admin view
  readonly destroyed = new ReplaySubject(1);
  private _mobileQueryListener: () => void;
  showDashBoardOnly: boolean = false;
  showUpperHeader: boolean = true
  exitFullScreen: boolean = false;
  breadCrumbItems: TreeNode[] = [];
  selectedBreadCrumb: TreeNode;
  @ViewChild('drawer', { static: false }) public drawer: MatDrawer;
  selectedPortal: ComponentPortal<any>;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    const currentFullScreenStatus: boolean = this.drawerService._showFullDashboard.getValue();
    if (event.keyCode === 27 && currentFullScreenStatus && (this.isDashboardPage || this.isUserAlarmsPage)) {
      this.exitFullScreen = true;
      this.drawerService._showFullDashboard.next(false);
    }
  }

  constructor(
    public readonly router: Router,
    public readonly route: ActivatedRoute,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public readonly dialog: MatDialog,
    public readonly commonService: CommonService,
    public readonly panelService: PanelService,
    public readonly drawerService: DynamicDrawerService<DataIFace>,
    private readonly dashboardSidebarService: DashboardSidebarService,
    readonly eventbusConnectionService: EventbusConnectionService) {
    this.mobileQuery = media.matchMedia('(min-width: 300px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    drawerService.portalComponent.subscribe((portal) => {
      this.selectedPortal = portal;
    });

    drawerService.output$.subscribe(() => {
      console.log('Some Output!!!!');
    });

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        this.drawerService.close(true);
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
      }

      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });

    this.panelService.lineChartsGlobal$.pipe(takeUntil(this.destroyed)).subscribe((lineChartsGlobal: IGlobalLineCharts) => {
      if (lineChartsGlobal) {
        console.log("annotations charts ", lineChartsGlobal)
        this.showIconButtons = true;
        this.showRangeValues = true;
        this.globalLineCharts = lineChartsGlobal;
        console.log('this.globalLineCharts:123 ', this.globalLineCharts);
      } else {
        this.showIconButtons = false;
        this.showRangeValues = false;
      }
    })

    this.drawerService.showFullDashboard$.pipe(takeUntil(this.destroyed)).subscribe((value: boolean) => {
      if (value) {
        this.showDashboard = value;
        this.isShowing = false;
        this.showDashBoardOnly = true;
      } else {
        this.showDashboard = value;
        this.isShowing = true;
        this.showDashBoardOnly = false;
        if (this.defaultCount === 0) {
          this.isShowing = false;
          this.defaultCount = 0;
        }
      }
    });

    const isAdmin: string = localStorage.getItem('isAdmin');
    const isSuperAdmin: string = localStorage.getItem('isSuperAdmin');
    if (isAdmin || isSuperAdmin) {
      if (JSON.parse(isAdmin)) {
        this.isAdminView = true;
        this.isShowing = true;
      } else {
        this.isAdminView = false;
        this.nonAdminSidebarMaterial();
      }
    } else {
      // screens switching toggle
      this.featuresDetails = JSON.parse(localStorage.getItem("Features")) || [];
      console.log('this.featuresDetails:Full ', this.featuresDetails);
      if (this.featuresDetails.length) {
        const isAdminView = this.featuresDetails.every((feature: IFeatures) => feature.is_config === true);
        if (isAdminView) {
          this.isAdminView = true;
          this.isShowing = true;
        } else {
          this.isAdminView = false;
          this.nonAdminSidebarMaterial();
        }
      }
    }

    // handling left side menu on admin side
    this.drawerService.showSideNav$.pipe(takeUntil(this.destroyed)).subscribe((isShowSideNav: boolean)=>{
      isShowSideNav ? (this.defaultCount - this.count === 3) ? this.isShowing = false : this.isShowing = true : this.isShowing = false;
    });

    // hide side nav when open filtered alarms against selected asset from map
    this.route.queryParams.pipe(takeUntil(this.destroyed)).subscribe((params: Params) => {
      if(params.assetId && this.isUserAlarmsPage){
        this.isShowing  = false;
        this.defaultCount = 0;
      }
    });

  }

  ngOnInit() {
    console.log('Full Component :>> ');
    this.panelService.features$.pipe(takeUntil(this.destroyed)).subscribe((featuresDetails: IFeatures[]) => {
      if (featuresDetails.length) {
        this.allFeaturesNames = [...featuresDetails].map((feature: IFeatures) => feature.name);
      }
    });

    this.panelService.leftSideMenuState$.pipe(takeUntil(this.destroyed)).subscribe((state: boolean) => {
      const isAdmin: boolean = JSON.parse(localStorage.getItem('isAdmin'));
      if (!isNull(state)) {
        if (isAdmin) {
          this.toggleSideNavBar();
        } else {
          this.toggleSideNavBarNonAdmin();
        }
      } else {
        if (isAdmin) {
          this.count = 1;
          this.toggleSideNavBar();
        } else {
          this.defaultCount = 0;
          this.toggleSideNavBarNonAdmin();
        }
      }
    });

    this.eventbusConnectionService.eventBroadcastResponse.next(null);
    this.eventbusConnectionService.eventSelectedUserResponse.next(null);

    // initialize websocket
    this.eventbusConnectionService.initializeEventBusConnection();

    // get token and check user roles to show corresponsing view
    const token = JSON.parse(localStorage.getItem("Token"));
    const featuresDetails: IFeatures[] = JSON.parse(localStorage.getItem('Features')) || [];
    if (featuresDetails.length) {
      console.log('featuresDetails:Full2 ', featuresDetails);
      this.allFeaturesNames = [...featuresDetails].map(feature => feature.name);
    }

    // screens switching toggle
    this.panelService.viewToggle$.pipe(takeUntil(this.destroyed)).subscribe((viewSide: string) => {
      if (viewSide) {
        if (viewSide === EViewTypes.ADMIN) {
          this.isAdminView = true;
          this.isShowing = true;
          // set menu-toggle handling properties
          this.defaultCount = 2;
          this.count = 0;
          this.iconWithText = true;
          this.drawerService._subMenuHandle.next(false);
        } else {
          this.isAdminView = false;
          this.nonAdminSidebarMaterial();
          // set menu-toggle handling properties
          this.defaultCount = 2;
          this.isShowing = true;
        }
      }

    });

    // isBackToDashboard page handler from alarms page
    this.panelService.isBackToDashbaord$.pipe(takeUntil(this.destroyed)).subscribe((isBackToDashbaord) => {
      if (isBackToDashbaord) {
        this.onAlarmsToggle();
      }
    });

    // to handle isLightMode change
    this.commonService.isLightMode$.pipe(takeUntil(this.destroyed)).subscribe((isLightMode: boolean)=>{
      setTimeout(() => {
        this.isLightMode = isLightMode;
      }, 0);
    });

    if (this.isUserAlarmsPage) {
      setTimeout(() => {
        this.defaultCount = 2;
        this.toggleSideNavBarNonAdmin();
      }, 0);
    }

  }

  ngAfterViewInit() {
    // this.drawer.closedStart.subscribe(() => this.selectedPortal = null);
    this.drawerService.toggle$.subscribe(state => {
      switch (state) {
        case 'OPEN':
          this.drawer.open();
          break;

        case 'CLOSE':
          this.drawer.close();
          break;
      }
    });

  }

  get isDashboardPage() {
    return this.router.url.includes('/dashboard');
  }

  get isUserAlarmsPage() {
    return this.router.url.includes(EEntityTypes.USER_ALARMS);
  }

  //#region nonAdminSidebarMaterial, toggleSideNavBar, toggleSideNavBarNonAdmin and onAlarmsToggle methods

  /**
 * Non admin side bar material
 */
  nonAdminSidebarMaterial() {
    this.dashboardSidebarService.selectedAsset$.pipe(takeUntil(this.destroyed)).subscribe(data => {
      console.log('selectedAssetNode: ', data);
      if (data) {
        this.selectedGroupName = '';
        this.selectedAssetName = '';
        this.selectedAssetName = data?.value ?? '';
        this.selectedAssetTimeStamp = '';
        this.selectedDashboardName = '';
      }
    });

    this.dashboardSidebarService.selectedGroupDashboards$.pipe(takeUntil(this.destroyed)).subscribe((groupDashboards: IPerspectiveDashboard[]) => {
      console.log('selectedGroupDashboards: ', groupDashboards);
      this.selectedGroupName = '';
      this.selectedAssetName = '';
      this.selectedAssetLiveStatus = '';
      this.selectedAssetTimeStamp = '';
      this.selectedDashboardName = '';
      if (groupDashboards.length) {
        this.selectedGroupName = groupDashboards[0].perspectiveGroupName;
      }
    });

    // asset live status and timeStamp
    this.dashboardSidebarService.selectedAssetTimeStamp$.pipe(takeUntil(this.destroyed)).subscribe((assetSummaryTimeDetail: ISummaryTimeStamp) => {
      this.selectedAssetTimeStamp = '';
      this.selectedAssetLiveStatus = '';
      if (assetSummaryTimeDetail?.linkedStatus) {
        this.selectedAssetLiveStatus = 'ONLINE';
        const assetLiveTimeStamp: Date = new Date(new Date(assetSummaryTimeDetail?.timeStamp).setDate(new Date(assetSummaryTimeDetail?.timeStamp).getDate()));
        this.selectedAssetTimeStamp = assetSummaryTimeDetail.timeStamp ? `${new Date(assetLiveTimeStamp)}` : '';
      } else {
        this.selectedAssetLiveStatus = 'OFFLINE';
        const assetLiveTimeStamp: Date = new Date(new Date(assetSummaryTimeDetail?.timeStamp).setDate(new Date(assetSummaryTimeDetail?.timeStamp).getDate()));
        this.selectedAssetTimeStamp = assetSummaryTimeDetail?.timeStamp ? `${new Date(assetLiveTimeStamp)}` : '';
      }
    });

    this.dashboardSidebarService.allDashboards$.pipe(takeUntil(this.destroyed)).subscribe(d => {
      this.dashboardsWithChildren = [];
      this.allDashboards = [];
      const dashboardsWithChildren: IDashboardResponse[] = [];
      this.allDashboards = d;
      if (this.allDashboards?.length) {
        this.allDashboards.forEach(d => {
          if (d.path !== '') {
            dashboardsWithChildren.push(d);
          }

          if (d.is_default) {
            this.selectedDashboardName = d.name;
          }
        });

        // remove duplicates
        this.dashboardsWithChildren = dashboardsWithChildren?.filter((value, index, self) => index === self.findIndex((t) => t.path === value.path));
        this.dashboardsWithChildren.forEach(c => {
          c.children = [];
        });

        this.dashboardsWithChildren?.forEach((c: IDashboardResponse) => {
          this.allDashboards.map(d => {
            if (c.path === d.path) {
              c.children.push(d);
            }
          })
        })
      } else {
        this.selectedDashboardName = '';
      }
      // console.log('this.allDashboards: full', this.allDashboards);
    });
  }

  /**
   * toggle side nav bar for admin
   */
  toggleSideNavBar() {
    let isSubMenuOpen: boolean;
    this.count++;

    // get submenu open status
    this.drawerService._subMenuHandle.pipe(takeUntil(this.destroyed)).subscribe((response: boolean) => {
      isSubMenuOpen = response;
      if (response) {
        this.iconWithText = response;
      }
    });

    this.iconWithText = !this.iconWithText;
    this.isShowing = true;
    // to close completely
    if (this.count === this.defaultCount) {
      this.iconWithText = false;
      this.isShowing = false;
      this.defaultCount = this.count + 3;
    }

    if (((this.count) % 3 === 1 || this.count === 1) && !this.iconWithText) {
      this.iconWithText = false;
      if (isSubMenuOpen) {
        this.isShowing = false;
        this.count = 2;
        this.defaultCount = this.count + 3;
      }
    }

    this.drawerService._subMenuHandle.next(false);
  }

  /**
   * toggle side nav bar for non-admin user
   */
  toggleSideNavBarNonAdmin() {
    if (this.defaultCount === 2) {
      this.isShowing = false;
      this.defaultCount = 0;
    } else {
      this.isShowing = true;
      this.defaultCount = 2;
    }
  }

  /**
   * on alarms toggle
   */
  onAlarmsToggle() {
    if (this.isDashboardPage) {
      this.router.navigate(["/user-alarms"]);
      this.defaultCount = 2;
      this.toggleSideNavBarNonAdmin();
    } else {
      this.router.navigate(["/dashboard"]);
      // to open non-admin side-menu (perspective tree)
      this.defaultCount = 0;
      this.toggleSideNavBarNonAdmin();
      // to load dashboard page (non-admin)
      this.isAdminView = true;
      setTimeout(() => {
        this.panelService._viewToggle.next(EViewTypes.DASHBOARD);
      }, 0);
    }
  }

  //#endregion

  //#region refreshRangeModel and openRangeModel methods

  /**
   * refresh range model
   */
  refreshRangeModel() {
    const headerRanges: IRangeForm = this.panelService._lineChartsHeaderRanges.getValue();
    const fromDate = new Date(headerRanges?.fromDate).getMonth().toString();
    if (headerRanges?.range) {
      this.panelService._lineChartsHeaderRanges.next(this.rangeModel);
    } else if (fromDate && fromDate !== 'NaN') {
      this.panelService._lineChartsHeaderRanges.next(this.rangeModel);
    } else {
      this.rangeModel.range = ERanges.D1;
      const selectedRange: IDropdown = this.ranges.find(range => range.value === this.rangeModel.range);
      const currentDateTime = new Date(Date.now());
      this.rangeModel = { range: ERanges.D1, rangeName: selectedRange.name, toDate: currentDateTime, fromDate: new Date(Date.now() - (86400000 * 1)) };
      this.panelService._lineChartsHeaderRanges.next(this.rangeModel);
    }

  }

  /**
   * open range model
   */
  openRangeModel() {
    this.showRangeValues = false;
    const headerRanges: IRangeForm = this.panelService._lineChartsHeaderRanges.getValue();
    const fromDate = new Date(headerRanges?.fromDate).getMonth().toString();

    if (headerRanges?.range) {
      const objRange: IRangeForm = this.panelService.getStartDate(headerRanges.range);
      this.rangeModel.range = headerRanges.range;
      const selectedRange: IDropdown = this.ranges.find(range => range.value === headerRanges.range);
      this.rangeModel.rangeName = selectedRange.name;
      this.rangeModel.toDate = objRange.toDate;
      this.rangeModel.fromDate = objRange.fromDate;
    } else if (fromDate && fromDate !== 'NaN') {
      this.rangeModel.toDate = headerRanges?.toDate;
      this.rangeModel.fromDate = headerRanges?.fromDate;
    } else {
      this.rangeModel.range = ERanges.D1;
      const selectedRange: IDropdown = this.ranges.find(range => range.value === this.rangeModel.range);
      this.rangeModel.rangeName = selectedRange.name;
      const currentDateTime = new Date(Date.now());
      this.rangeModel = { range: ERanges.D1, rangeName: selectedRange.name, toDate: currentDateTime, fromDate: new Date(Date.now() - (86400000 * 1)) };
    }

    const dialogRef = this.dialog.open(RangeModelComponent, { data: this.rangeModel, width: '40%' });
    dialogRef.afterClosed().toPromise().then((rangeFormData: IRangeForm) => {
      if (rangeFormData?.range || (rangeFormData?.fromDate && rangeFormData?.toDate)) {
        if (rangeFormData.range) {
          const objRange: IRangeForm = this.panelService.getStartDate(rangeFormData.range);
          this.rangeModel.range = rangeFormData.range;
          const selectedRange: IDropdown = this.ranges.find(range => range.value === rangeFormData.range);
          this.rangeModel.rangeName = selectedRange.name;
          this.rangeModel.toDate = objRange.toDate;
          this.rangeModel.fromDate = objRange.fromDate;
        } else {
          this.rangeModel.range = null;
          this.rangeModel.toDate = rangeFormData.toDate;
          this.rangeModel.fromDate = rangeFormData.fromDate;
        }

        this.showRangeValues = true;
        this.showIconButtons = true;
        this.panelService._lineChartsHeaderRanges.next(this.rangeModel);
      }
    });

  }

  //#endregion

  //#region upperHeader, buildBreadCrumbs, onBreadCrumbItemClick and getSelectedDashboard methods

  /**
   * upper header portion
   * @param isShow boolean
   */
  upperHeader(isShow: boolean) {
    this.showUpperHeader = isShow;
  }

  /**
   * build breadcrumbs with data
   * @param treeNodes
   */
  buildBreadCrumbs(treeNodes: TreeNode[]) {
    this.breadCrumbItems = [...treeNodes.reverse()];
  }

  /**
   * selected breadcumb on breadcrumb item click
   * @param selectedNode selectedBreadCrumb
   */
  onBreadCrumbItemClick(selectedNode: TreeNode) {
    this.selectedBreadCrumb = Object.assign({}, selectedNode); ;
    this.breadCrumbItems = this.breadCrumbItems.slice(0, this.breadCrumbItems.findIndex((item) => item.label === selectedNode.label) + 1);
  }

  /**
   * get selected dashbaord name
   * @param selectedDashboardName selected dashboard name
   */
  getSelectedDashboard(selectedDashboardName: string) {
    this.selectedDashboardName = selectedDashboardName || '';
  }

  //#endregion

  ngOnDestroy(): void {
    this.eventbusConnectionService.closeSocketConnection();
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.destroyed.next();
    this.destroyed.complete();
  }

}